import { combineReducers } from "redux";

import authReducer from "./auth/reducers";
import apiReducers from "./api/reducers";
import staffReducers from "./staff/reducers";
import agentReducers from "./agent/reducers";
import agentStaffReducers from "./agentStaff/reducers";
import partnerReducers from "./partner/reducers";
import accountReducers from "./accounts/reducers";

import userTypeReducer from "./userType/reducer";
import logsReducers from "./logs/reducers";
import tarrifReducers from "./tarrif/reducers";
import merchantReducers from "./merchant/reducers";
import { ACTION_RESET_APP_STATE } from "../constant";

const appReducers = combineReducers({
  auth: authReducer,
  api: apiReducers,
  staff: staffReducers,
  partner: partnerReducers,
  agent: agentReducers,
  agentStaff: agentStaffReducers,
  accounts: accountReducers,
  logs: logsReducers,
  tarrif: tarrifReducers,
  merchant: merchantReducers,

  user: userTypeReducer,
});

const rootReducer = (state, action) => {
  //added to prevent stacking on loading possibility
  if (action.type === ACTION_RESET_APP_STATE) {
    return appReducers(undefined, action);
  }
  return appReducers(state, action);
};

export default rootReducer;
